import Config from '../Data/Config.json'
import { BrandName } from '../Typescript'
import { isDevEnv } from '../Utils'

class OneTrust {
    private _initialized = false
    private _brand = BrandName.msnbc

    async init(brand: BrandName) {
        if (!this._initialized) {
            this._initialized = true
            this._setupListeners()

            // Forcing MS NOW since CNBC loads OT from Launch Rules
            if (brand === BrandName.msnbc) {
                this._brand = brand
                await Promise.allSettled([this._injectCookiesConsentNotice(), this._injectUSP()])
            }
        }
    }

    private _setupListeners() {
        window.addEventListener('OTConsentApplied', function () {
            location.reload()
        })

        window.OptanonWrapper = () => {
            const customEvent = new CustomEvent('oneTrustLibraryLoaded')
            window.dispatchEvent(customEvent)
        }
    }

    private async _injectCookiesConsentNotice() {
        if (this._config.apiKey) {
            const urlPath = Config.onetrust.scripts.cookieNotice.replace(
                '[API_KEY]',
                this._config.apiKey
            )

            return new Promise<void>((resolve, reject) => {
                const script = document.createElement('script')
                script.setAttribute('type', 'text/javascript')
                script.setAttribute('charset', 'UTF-8')
                script.setAttribute('data-domain-script', this._config.apiKey)
                script.setAttribute('integrity', this._config.integrity)
                script.setAttribute('crossorigin', 'anonymous')
                script.src = urlPath
                script.onload = () => {
                    resolve()
                }
                script.onerror = () => {
                    reject()
                }
                document.head && document.head.appendChild(script)
            })
        }
    }

    private async _injectUSP() {
        if (this._config.apiKey) {
            const urlPath = Config.onetrust.scripts.usp

            return new Promise<void>((resolve, reject) => {
                const script = document.createElement('script')
                script.setAttribute('id', 'privacyCookie')
                script.setAttribute('type', 'text/javascript')
                script.setAttribute('charset', 'UTF-8')
                script.setAttribute('ccpa-opt-out-ids', 'USP')
                script.setAttribute('ccpa-opt-out-geo', 'US')
                script.setAttribute('ccpa-opt-out-lspa', 'false') // cspell:disable-line
                script.src = urlPath
                script.onload = () => {
                    resolve()
                }
                script.onerror = () => {
                    reject()
                }
                document.head && document.head.appendChild(script)
            })
        }
    }

    private get _config() {
        const brandKey = this._brand as keyof (typeof Config)['onetrust']['brands']
        const envKey = isDevEnv ? 'dev' : 'prod'
        return Config.onetrust.brands[brandKey][envKey]
    }
}

export default new OneTrust()
